import React from 'react';
import { ShieldCheckIcon, VideoIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-dark" data-id="element-56" data-mp="844al66a2vea">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-57" data-mp="m4ykjt8z54f2">
        <h2 id="cierre" className="font-display text-xl uppercase leading-[1.1] tracking-tight text-gold sm:text-3xl" data-id="element-58" data-mp="m2lt8phbthpc">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm font-medium leading-snug text-ink-onDarkMuted" data-id="element-59" data-mp="vwuhv238kqi8">
          Podés seguir guardando videos y preguntándote qué deberías aprender
          primero. O podés comenzar hoy a construir una habilidad técnica
          siguiendo una ruta desde cero.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm font-extrabold leading-snug text-white" data-id="element-60" data-mp="zuihgifvj7gg">
          No necesitás saber instalar cámaras o alarmas para empezar. Necesitás
          dar el primer paso.
        </p>

        <Reveal className="mt-3 rounded-xl border-4 border-gold bg-white p-4 sm:p-5" data-id="element-61" data-mp="2m342czmcwgfp">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block overflow-hidden rounded-lg transition-transform duration-200 ease-soft hover:scale-[1.01]" data-id="element-62" data-mp="2r1xgmu9gwbgx">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="mx-auto w-full max-w-xs" data-id="element-63" data-mp="301k8aocea2ws" />
          </a>

          <p className="mt-3 flex items-center justify-center gap-1.5 text-[0.8rem] font-extrabold uppercase leading-tight tracking-tight text-brand sm:text-base" data-id="element-64" data-mp="39sf3wjbj6euw">
            <VideoIcon size={16} className="flex-shrink-0" aria-hidden="true" data-id="element-65" data-mp="3etcnn0c6vgyi" />
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-base uppercase text-brand-dark sm:text-lg" data-id="element-66" data-mp="3iqqs6eoxd0k6">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1.5 text-[0.72rem] font-extrabold uppercase tracking-wide text-gold-dark sm:text-sm" data-id="element-67" data-mp="1eq1oy5fbetfd">
            Valor de los bonos: {BONUS_TOTAL}
          </p>

          <p className="mt-2 text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-ink-muted" data-id="element-68" data-mp="1npyjuosasoiv">
            Hoy:
          </p>
          <p className="font-display text-5xl leading-none text-alert sm:text-6xl" data-id="element-69" data-mp="22drz28dh1p0x">
            {PRICE}
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-70" data-mp="1xf89zz3kzx4c">
            Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.7rem] font-semibold text-ink-muted sm:text-xs" data-id="element-71" data-mp="27dxttxf1frn8">
            <span className="flex items-center gap-1.5" data-id="element-72" data-mp="h2jk35orybgn">
              <ZapIcon size={13} className="text-brand" aria-hidden="true" data-id="element-73" data-mp="czwn6qd8y0cl" />
              Acceso Inmediato
            </span>
            <span aria-hidden="true" data-id="element-74" data-mp="2vpyvp0gmygl">•</span>
            <span data-id="element-75" data-mp="2y2p0pgdgf4q">Entrega Digital</span>
            <span aria-hidden="true" data-id="element-76" data-mp="6y31w5ntoi9o">•</span>
            <span className="flex items-center gap-1.5" data-id="element-77" data-mp="6x1se5mgg3u2">
              <ShieldCheckIcon size={13} className="text-brand" aria-hidden="true" data-id="element-78" data-mp="3pc2kp37vh1w4" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}